"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sequencesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dictionary_evidence_1 = require("../../composite/evidence/dictionary-evidence/dictionary-evidence");
const evidence_1 = require("../../composite/evidence/evidence");
const sequences_fields_1 = require("./sequences-fields");
const sequences_columns_1 = require("./sequences-columns");
const sequences_schema_1 = require("./sequences-schema");
function sequencesFactory(url, reportTag, defaultSorts) {
    return function Sequences() {
        const intl = react_intl_1.useIntl();
        const validationSchema = sequences_schema_1.useValidationSchema();
        const evidence = dictionary_evidence_1.useDictionaryEvidence({
            identifier: 'SEQUENCES',
            apiProps: {
                url,
            },
            tableProps: {
                columns: sequences_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'EAS_SEQUENCES_TABLE_TITLE',
                    defaultMessage: 'Číselné řady',
                }),
                reportTag,
                defaultSorts,
            },
            detailProps: {
                FieldsComponent: sequences_fields_1.SequencesFields,
                validationSchema,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.sequencesFactory = sequencesFactory;
//# sourceMappingURL=sequences.js.map